import { CostCentersEmployeesStructuredAssignmentsQuery } from 'generated/resources/graphql'

import { ACTIVE, TERMINATED } from './constants'
import {
  familyLabelForChild,
  familyLabelForParent,
  functionLabelForChild,
  functionLabelForParent,
  roleLabelForChild,
  roleLabelForParent,
} from './labels'
import { Filters, FormattedCostCenterEmployeeWithStructuredAssignment } from './types'

export const mapEmployeeData = (data: CostCentersEmployeesStructuredAssignmentsQuery) => {
  const edges = data.employees.employeesConnection.edges
  return edges.map(({ node }) => ({
    ...node,
    jobCatalogFamilyName: familyLabelForParent(node),
    jobCatalogFunctionName: functionLabelForParent(node),
    jobCatalogRoleName: roleLabelForParent(node),
    startDate: node.structuredAssignments.edges[0]?.node?.startDate,
    percentage: node.structuredAssignments.edges.reduce(
      (acc, value) => acc + Number(value.node.percentage),
      0
    ),
  }))
}

export const mapChildrenData = (item: FormattedCostCenterEmployeeWithStructuredAssignment) => {
  return Promise.resolve({
    records: item.structuredAssignments.edges.map(({ node }) => ({
      ...item,
      jobCatalogFamilyName: familyLabelForChild(node, item),
      jobCatalogFunctionName: functionLabelForChild(node, item),
      jobCatalogRoleName: roleLabelForChild(node, item),
      percentage: Number(node.percentage),
      startDate: '',
      isChild: true,
    })),
    type: 'detailed' as const,
  })
}

const filterByAssignmentStatus = (assignmentStatus?: boolean[]) => {
  if (
    assignmentStatus === undefined ||
    assignmentStatus.length === 0 ||
    (assignmentStatus.includes(true) && assignmentStatus.includes(false))
  ) {
    return {}
  }

  return { withCostCenterAssignments: assignmentStatus.includes(true) }
}

const filterByPeopleStatus = (status?: string[]) => {
  if (!status?.length || (status.includes(TERMINATED) && status.includes(ACTIVE))) {
    return {}
  }

  return { accessStatus: status }
}

export const mapVariables = ({
  search,
  sortings,
  filters,
}: {
  search?: string
  filters?: Filters
  sortings?: Array<{ field: string; order: string }>
}) => {
  return {
    search: search,
    sortOrder: sortings?.[0],
    legalEntityIds: filters?.legalEntityIds?.length ? filters?.legalEntityIds : undefined,
    teamIds: filters?.teamIds?.length ? filters?.teamIds : undefined,
    costCenterIds: filters?.costCenterIds?.length ? filters?.costCenterIds : undefined,
    employeeIds: filters?.employeeIds?.length ? filters?.employeeIds : undefined,
    ...filterByAssignmentStatus(filters?.withCostCenterAssignments),
    ...filterByPeopleStatus(filters?.peopleStatus),
  }
}
